import { atom } from "recoil";

export const DicDoanhNghiepState = atom({
  key: "DicDoanhNghiepState",
  default: undefined,
});
